import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppShellService } from 'app/core/app-shell/app-shell.service';

/**
 * PersonaHomeGuard — GAP-MEET-UX-213. Guards the trailing wildcard route in
 * `app.routing.ts` so an unmatched URL (mistyped or a phantom nav link) never
 * renders a blank shell. Instead it redirects to the current persona's home
 * route, reusing `AppShellService.homeRouteForPersona` / `getPersonaRole` —
 * the same resolution the rest of the app already uses (no new persona
 * logic). A signed-out user resolves to the `is` default persona, whose home
 * route (`/home`) is itself guarded and bounces to sign-in.
 */
@Injectable({ providedIn: 'root' })
export class PersonaHomeGuard implements CanActivate {
    constructor(
        private router: Router,
        private appShellService: AppShellService
    ) {}

    canActivate(
        _route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): UrlTree {
        return this.router.parseUrl(
            this.appShellService.homeRouteForPersona(this.appShellService.getPersonaRole())
        );
    }
}
